import DetailsSubpanels from './container/index';

export default DetailsSubpanels;



// WEBPACK FOOTER //
// ./src/components/page/DetailsSubpanels/index.js